import {
    IBook, IDashboardLessons,
    ILessonLight,
} from '@/interfaces';
import { DashboardState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setDashboardLessons(state: DashboardState, payload: IDashboardLessons[]) {
        state.dashboardLessons = payload;
    },
    setNewBook(state: DashboardState, payload: IBook | null) {
        state.newBook = payload;
    },
};

const {commit} = getStoreAccessors<DashboardState | any, State>('');

export const commitSetDashboardLessons = commit(mutations.setDashboardLessons);
export const commitSetNewBook = commit(mutations.setNewBook);
